import React, { useEffect, useState } from 'react'
import _ from 'lodash';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../../../../../../../hooks/hooks';
import PageLoader from '../../../../../../../../components/PageLoader';
import GatewayCockpitInsightNPComponent from '../components/insights.component';
import { selectProductInsightsQueryItems } from '../../../../../../../../redux/product-insights/selector';
import { productInsights } from '../../../../../../../../redux/product-insights/action';

const ManagementGatewayCockpitInsightsNP = () => {
    const navigate = useNavigate()
    const dispatch = useAppDispatch()
    const parmas: any = useParams()
    const insightsNPQueryData = useSelector(selectProductInsightsQueryItems)
    const [isQuery, setIsQuery] = useState<boolean>(false)
    const [isLoading, setIsLoading] = useState<boolean>(true)
    const [selectedInsightsNPs, setSelectedInsightsNPs] = useState<any>([])

    const fetchGatewayCockpitInsightNPQueryById = () => {
        dispatch(productInsights.query({
            url: `https://catalog.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/catalog/catalog-collections/insights/fetch-detail`,
            entity: 'productInsights',
            jsonData:
            {
                Context: {},
                Records: [
                    {
                        Id: Number(parmas?.id),
                        InsightsTypeId: 20
                    }
                ]
            }
        })).then(() => {
            setIsQuery(true)
        })
    }

    useEffect(() => {
        if (parmas?.id > 0) {
            fetchGatewayCockpitInsightNPQueryById()
            setIsLoading(false)
        } else {
            setIsLoading(false)
        }
    }, []
    )

    useEffect(() => {
        if (isQuery) {
            setSelectedInsightsNPs(insightsNPQueryData?.result?.items)
        }
    }, [isQuery]
    )

    const back = () => {
        navigate(-1)
    }

    return (
        <>
            {insightsNPQueryData?.isLoading ? <PageLoader /> :
                <GatewayCockpitInsightNPComponent
                    selectedInsightsNPs={selectedInsightsNPs}
                    back={back}
                />
            }
        </>
    )
}

export default ManagementGatewayCockpitInsightsNP;